<template>
  <div :class="{ 'border border-error-40': erro, 'bg-cinza-1': estaArrastando }">
    <div class="p-8 text-center w-100" :class="{ 'disabled': disabled }"
      @click="abrirSelecaoArquivo" @dragenter.prevent="lidarComDragAndDrop('entrar')"
      @dragover.prevent="lidarComDragAndDrop('sobre')" @dragleave="lidarComDragAndDrop('sair')"
      @drop.prevent="lidarComDragAndDrop('soltar', $event)" ref="custom-input-file" tabindex="0">
      <div class="mb-3"> 
        <i class="fa fa-file text-primary-30 font-size-16"></i>
      </div>
      <div class="mb-3">
        <p class="font-size-14 font-weight-400 text-cinza-texto mb-1">{{ titulo }}</p>
        <p v-if="textoFormatoEsperado" class="font-size-12 font-weight-400 text-cinza-5">{{ textoFormatoEsperado }}</p>
      </div>
      <button type="button" class="btn btn-nd-primary btn-no-shadow" @click.stop="abrirSelecaoArquivo"
        :disabled="disabled">
        {{ textoBotao }}
      </button>
      <input type="file" :name="name" ref="input-file" multiple :accept="accept" :disabled="disabled"
        @change="lidarComSelecaoArquivo" class="hidden">
      <template v-if="campoMantidos">
        <input type="hidden" :name="campoMantidos" value="">
        <input v-for="arquivo in arquivosMantidos" :key="`mantido-${arquivo.id}`" type="hidden"
          :name="campoMantidos" :value="arquivo.name">
      </template>
    </div>
    <hr v-if="arquivosSelecionados.length > 0" class="mt-0 mb-3">
    <div v-if="arquivosSelecionados.length > 0" class="lista-arquivos-selecionados">
      <div v-for="(arquivo, index) in arquivosSelecionados" :key="arquivo.id"
        class="d-flex justify-content-between align-items-center gap-3 px-4 py-2 font-size-12 font-weight-400 bg-arquivo-item item-arquivo">
        <div class="d-flex align-items-center flex-grow-1">
          <a href="#" @click.prevent.stop="baixarArquivo(arquivo)" class="text-decoration-underline text-primary text-break">
            {{ arquivo.name }}
          </a>
        </div>
        <span v-if="categoriaDoArquivo(arquivo)" class="nods-badges sm-nods-badges bg-cinza-2 text-cinza-7 font-size-10">
          {{ categoriaDoArquivo(arquivo) }}
        </span>
        <i class="fa-solid fa-trash font-size-16 text-cinza-5 cursor-pointer" @click.prevent.stop="removerArquivo(index)"
          :class="{ 'disabled': readOnly }"></i>
      </div>
    </div>
    <div class="font-size-12 font-weight-400 text-cinza-5 mt-2 px-6 mb-3">
      {{ textoContadorArquivos }}
    </div>
  </div>
  <div v-if="erro" class="mt-2 d-flex align-items-center gap-2">
    <i class="fa fa-exclamation-circle text-error-40"></i>
    <p class="font-size-12 font-weight-400 text-error-40 mb-0">
      {{ mensagemErro }}
    </p>
  </div>
</template>

<script>
import { tipoArquivoInvalido, extrairExtensaoArquivo, construirObjetoArquivo, formatarExtensoesParaExibicao } from '../helpers/fileValidation.js'

export default {
  name: 'MultipleSelectFile',
  emits: ['update:modelValue', 'error:invalid-type', 'error:upload', 'onOpenSelecaoArquivo', 'remover'],
  props: {
    modelValue: {
      required: false,
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: [String, Array],
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      required: false,
      default: 'Selecione um documento ou arraste e solte aqui'
    },
    erro: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    textoBotao: {
      type: String,
      required: false,
      default: 'Selecionar'
    },
    arquivosSalvos: {
      type: [Array, String],
      required: false,
      default: () => []
    },
    campoMantidos: {
      type: String,
      required: false,
    },
    categoriaSelecionada: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      arquivosSelecionados: [],
      estaArrastando: false,
      contadorIdArquivo: 0,
      escritaDeFileListIndisponivel: false,
      desinscrever: () => { },
      desinscreverSubmit: () => { }
    }
  },
  computed: {
    textoFormatoEsperado() {
      if (this.accept) {
        return `Formato esperado: ${formatarExtensoesParaExibicao(this.accept)}`
      }
      return null
    },
    textoContadorArquivos() {
      const plural = this.arquivosSelecionados.length > 1 ? 's' : ''
      return `${this.arquivosSelecionados.length} arquivo${plural} selecionado${plural}`
    },
    mensagemErro() {
      if (typeof this.erro === 'string') {
        return this.erro
      }
      return 'Campo obrigatório'
    },
    listaDeArquivosSalvos() {
      if (typeof this.arquivosSalvos !== 'string') return this.arquivosSalvos

      try {
        return JSON.parse(this.arquivosSalvos)
      } catch (erro) {
        return []
      }
    },
    arquivosMantidos() {
      return this.arquivosSelecionados.filter((arquivo) => !arquivo.inputFile)
    }
  },
  methods: {
    categoriaDoArquivo(arquivo) {
      if (arquivo.inputFile) return this.categoriaSelecionada

      return arquivo.categoria
    },
    abrirSelecaoArquivo() {
      if (this.disabled) return;
      this.$emit('onOpenSelecaoArquivo')
      this.$refs['input-file'].click()
      this.$refs['custom-input-file'].focus()
    },
    lidarComDragAndDrop(acao, ev = null) {
      if (this.disabled) return;

      if (acao === 'entrar' || acao === 'sobre') {
        this.estaArrastando = true
        return;
      }
      if (acao === 'soltar' && ev) {
        const arquivos = Array.from(ev.dataTransfer.files)
        this.processarArquivos(arquivos)
      }
      this.estaArrastando = false
    },
    lidarComSelecaoArquivo(ev) {
      const arquivos = Array.from(ev.target.files)
      this.processarArquivos(arquivos)
    },
    gerarIdArquivo() {
      this.contadorIdArquivo += 1
      return `arquivo-${Date.now()}-${this.contadorIdArquivo}`
    },
    construirArquivo(arquivo, id) {
      return construirObjetoArquivo(arquivo, id || this.gerarIdArquivo())
    },
    processarArquivos(arquivos) {
      const arquivosValidos = []
      let contadorProcessados = 0
      let totalArquivosValidos = 0
      arquivos.forEach(arquivo => {
        if (!this.validarArquivo(arquivo)) return
        totalArquivosValidos++
        const dadosArquivo = this.construirArquivo(arquivo)
        this.lerArquivo(arquivo, dadosArquivo, arquivosValidos, () => {
          contadorProcessados++
          if (contadorProcessados === totalArquivosValidos) {
            this.arquivosSelecionados = [...this.arquivosSelecionados, ...arquivosValidos]
            this.emitirMudanca()
          }
        })
      })
    },
    validarArquivo(arquivo) {
      const fileExtension = extrairExtensaoArquivo(arquivo.name)
      if (tipoArquivoInvalido(fileExtension, this.accept)) {
        this.$emit('error:invalid-type', `Arquivo de tipo .${fileExtension} é inválido`)
        return false
      }
      return true
    },
    lerArquivo(arquivo, dadosArquivo, arquivosValidos, callback) {
      if (arquivo instanceof File) {
        let reader = new FileReader()
        reader.onload = () => {
          dadosArquivo.buffer = reader.result
          dadosArquivo.isUploaded = true

          arquivosValidos.push(dadosArquivo)
          callback()
        }
        reader.onerror = () => {
          this.$emit('error:upload', 'Ocorreu um erro ao ler o arquivo')
        }
        reader.readAsArrayBuffer(arquivo)
      }
    },
    removerArquivo(indice) {
      if (this.readOnly) return;
      const arquivo = this.arquivosSelecionados[indice]
      if (arquivo.url && arquivo.url.startsWith('blob:')) {
        URL.revokeObjectURL(arquivo.url)
      }
      this.arquivosSelecionados.splice(indice, 1)
      this.emitirMudanca()
      this.$emit('remover', arquivo)
    },
    baixarArquivo(arquivo) {
      if (arquivo.url && !arquivo.url.startsWith('blob:')) {
        window.open(arquivo.url, '_blank', 'noopener,noreferrer');
        return;
      }
      if (arquivo.buffer) {
        try {
          const blob = new Blob([arquivo.buffer], {
            type: arquivo.type || 'application/octet-stream'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = arquivo.name
          link.click()
          window.URL.revokeObjectURL(url)
        } catch (erro) {
          this.$emit('error:upload', 'Ocorreu um erro ao preparar o arquivo para download')
        }
      }
    },
    sincronizarInputNativo() {
      const input = this.$refs['input-file']
      if (!input || typeof DataTransfer === 'undefined') return

      try {
        const transferencia = new DataTransfer()
        this.arquivosSelecionados.forEach((arquivo) => {
          if (arquivo && arquivo.inputFile instanceof File) {
            transferencia.items.add(arquivo.inputFile)
          }
        })
        input.files = transferencia.files
      } catch (erro) {
        this.escritaDeFileListIndisponivel = true
      }
    },
    escutarSubmitDoFormulario() {
      const formulario = this.$refs['input-file'] && this.$refs['input-file'].form
      if (!formulario) return

      const aoSubmeter = () => this.sincronizarInputNativo()
      formulario.addEventListener('submit', aoSubmeter)
      this.desinscreverSubmit = () => formulario.removeEventListener('submit', aoSubmeter)
    },
    emitirMudanca() {
      this.sincronizarInputNativo()
      this.$emit('update:modelValue', this.arquivosSelecionados)
    },
    semearArquivosSalvos() {
      const salvos = this.listaDeArquivosSalvos

      if (!Array.isArray(salvos) || salvos.length === 0) return

      const normalizados = salvos.map((arquivo, indice) => ({
        id: arquivo.id || `salvo-${indice}-${arquivo.name}`,
        name: arquivo.name,
        url: arquivo.url,
        categoria: arquivo.categoria,
        isUploaded: true,
      }))

      this.arquivosSelecionados = [...normalizados, ...this.arquivosSelecionados]
    }
  },
  mounted() {
    this.desinscrever = this.$watch('modelValue', (newValue) => {
      if (!newValue || newValue.length === 0) {
        this.arquivosSelecionados = []
        this.$refs['input-file'].value = null
        return
      }
      this.arquivosSelecionados = [...newValue]
      this.sincronizarInputNativo()
    }, { immediate: true })

    this.semearArquivosSalvos()
    this.escutarSubmitDoFormulario()
  },
  beforeUnmount() {
    this.desinscrever()
    this.desinscreverSubmit()
  },
}
</script>
